export default __webpack_public_path__ + "static/media/26_SchererGruppe-DTM-Documentary-EschweilerPhotography_21A3875.84374f40.jpg";